export default __webpack_public_path__ + "static/media/tabuleiro.a6eb7d11.webp";